module.exports = __webpack_public_path__ + "media/images/success-img/layer-8-27ccd48709478256ea1b6e33f1eb5312.png";